import React, { Component, useEffect, useRef, useState } from 'react';
import './index.scss';
import { useReactToPrint } from 'react-to-print';
import { Col, Row, Form, Input, Button, InputNumber } from 'antd';
import { useGetFxBarcodeDetails, useUpdateFxBarcodeGeneratedCount } from '../../hooks/useOrders';
import Barcode from 'react-barcode';
import CompanyDropdown from '../../components/CompanyDropdown';
import OrderDropdown from '../../components/OrderDropdown';
import { PrinterOutlined } from '@ant-design/icons';

export default function PrintLabelPage() {
    const [form] = Form.useForm();

    const [selectedCompany, setSelectedCompany] = useState(null);
    const [selectedOrder, setSelectedOrder] = useState(null);

    const [details, setDetails] = useState({
        pageWidth: 210,
        pageHeight: 297,
        totalCount: 20,
        pagePadding: {
            top: 10,
            right: 5,
            bottom: 10,
            left: 5,
        },
        gapBetweenBarcodes: {
            horizontal: 8,
            vertical: 8,
        },
        columns: 3,
        rows: 7,
        companyCode: null,
        batchNumber: null,
        studioCode: null,
        startAt: null,
    });

    const isBarcodeViewValid = () => {
        return !!details?.companyCode && !!details?.batchNumber && !!details?.studioCode && !!details?.startAt;
    };

    const { data: barcodeGenDetails, isFetching: isFetchingOrderDetails, isFetched: isFetchedOrderDetails } = useGetFxBarcodeDetails(selectedOrder);
    const UpdateFxBarcodeGeneratedCountMutation = useUpdateFxBarcodeGeneratedCount();

    const pageCount = () => {
        const n = Math.ceil(details.totalCount / (details.rows * details.columns));
        return n;
    };

    const componentRef = useRef();

    const handlePrint2 = () => {
        handlePrint();
    };

    const getGeneratedBarcodesList = () => {
        const pages = pageCount();
        const totalBarcodesGenerated = details.columns * details.rows * pages;

        const barcodes = [];
        for (let i = 0; i < totalBarcodesGenerated; i++) {
            const itemSeqNumber = details.startAt + i;
            const barcode = `${details.companyCode}${details.batchNumber}${details.studioCode}1B${String(itemSeqNumber).padStart(
                3,
                '0'
            )}`.toLocaleUpperCase();
            barcodes.push(barcode);
        }
        return barcodes;
    };

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        onAfterPrint: () => {
            console.log('After print');
            const barcodes = getGeneratedBarcodesList();
            UpdateFxBarcodeGeneratedCountMutation.mutate([
                barcodeGenDetails?.data?.orderId,
                details?.rows * details?.columns * pageCount(),
                barcodes,
            ]);
            form.resetFields();
            setDetails(prev => {
                const resetItems = {
                    companyCode: null,
                    batchNumber: null,
                    studioCode: null,
                    startAt: null,
                };
                const newState = { ...prev, ...resetItems };
                return newState;
            });
        },
    });

    const GeneratePages = () => {
        const count = pageCount();
        return (
            <>
                {Array.from({ length: count }, (_, index) => {
                    return <GeneratePage index_page={index} key={`Page${index}`} />;
                })}
            </>
        );
    };

    const GeneratePage = ({ index_page }) => {
        return (
            <div className="page">
                {Array.from({ length: details.rows }, (_, index) => {
                    return <GenerateRow index_page={index_page} index_row={index} key={`Row:${index_page}${index}`} />;
                })}
                <span className="page-footer">{`Page ${index_page + 1} of ${pageCount()}`}</span>
            </div>
        );
    };

    const GenerateRow = ({ index_page, index_row }) => {
        return (
            <Row className="row-page" gutter={[details.gapBetweenBarcodes.horizontal / 2, 0]}>
                {Array.from({ length: details.columns }, (_, index) => {
                    const itemSeqNumber = details.startAt + index_page * details.columns * details.rows + index_row * details.columns + index;
                    return (
                        <Col span={Math.floor(24 / details.columns)} key={itemSeqNumber}>
                            <div className="col-page-wrapper">
                                <div className="col-page">
                                    <span>FLIXSTUDIO</span>
                                    <Barcode
                                        value={`${details.companyCode}${details.batchNumber}${details.studioCode}1B${String(itemSeqNumber).padStart(
                                            3,
                                            '0'
                                        )}`.toLocaleUpperCase()}
                                        // height={100}
                                        fontSize={30}
                                        format={'CODE128'}
                                        displayValue={true}
                                        // width={2}
                                        marginTop={0}
                                        marginBottom={0}
                                        className="barcode"
                                        // background="#ccffff"
                                    />
                                </div>
                            </div>
                        </Col>
                    );
                })}
            </Row>
        );
    };

    const onReset = () => {
        console.log('RESET');
        setDetails(prev => {
            const resetItems = {
                companyCode: null,
                batchNumber: null,
                studioCode: null,
                startAt: null,
            };
            const newState = { ...prev, ...resetItems };
            return newState;
        });
    };

    const onFinish = ({
        pageHeight,
        pageWidth,
        totalCount,
        top,
        right,
        bottom,
        left,
        horizontal,
        vertical,
        columns,
        rows,
        companyCode,
        batchNumber,
        studioCode,
        startAt,
    }) => {
        setDetails({
            pageWidth: pageWidth,
            pageHeight: pageHeight,
            totalCount: totalCount,
            pagePadding: {
                top: top,
                right: right,
                bottom: bottom,
                left: left,
            },
            gapBetweenBarcodes: {
                horizontal: horizontal,
                vertical: vertical,
            },
            columns: columns,
            rows: rows,
            companyCode: companyCode,
            batchNumber: barcodeGenDetails?.data?.batchNo,
            studioCode: barcodeGenDetails?.data?.studioCode?.length > 0 ? barcodeGenDetails?.data?.studioCode[0] : null,
            startAt: barcodeGenDetails?.data?.FxBarcodes?.generated + 1,
        });

        document.title = `Barcodes:${companyCode}${studioCode}B${columns}x${rows} ${startAt}-${totalCount}`;
    };

    useEffect(() => {
        return () => {
            document.title = 'Flixstudio Dashboard';
        };
    }, []);

    return (
        <React.Fragment>
            <style>
                {`
                    box-sizing: border-box;
                    @media print {
                        @page {
                            size: ${details.pageWidth}mm ${details.pageHeight}mm;
                        }
                        html, body {
                            height: initial !important;
                            overflow: initial !important;
                        }
                    }

                    .page {
                        size: ${details.pageWidth}mm ${details.pageHeight}mm;
                        width: ${details.pageWidth}mm;
                        height: ${details.pageHeight}mm;
                        padding: ${details.pagePadding.top}mm ${details.pagePadding.right}mm ${details.pagePadding.bottom}mm ${
                    details.pagePadding.left
                }mm;
                    }

                    .row-page {
                        width: 100%;
                        height: calc(100% / ${details.rows});
                        padding: ${details.gapBetweenBarcodes.vertical / 2}px;
                    }
                `}
            </style>

            <div className="pageWrapper">
                <div className="print-setting-area">
                    <Form
                        form={form}
                        onFinish={onFinish}
                        onReset={onReset}
                        onChange={() => {
                            console.log('onchange');
                        }}
                        labelAlign="right"
                        className="print-setting-form"
                        layout="horizontal"
                    >
                        <div className="padding-form-box">
                            <p>Order details</p>
                            <Form.Item label="Company Code" name="companyCode">
                                <CompanyDropdown
                                    onChange={item => {
                                        console.log(item);
                                        form.setFieldValue('companyCode', item?.value);
                                        setSelectedCompany(item?.value);
                                    }}
                                />
                            </Form.Item>
                            <Form.Item label="Order" name="orderId">
                                <OrderDropdown
                                    onChange={item => {
                                        form.setFieldValue('orderId', item?.value);
                                        setSelectedOrder(item?.value);
                                    }}
                                    selectedCompanies={selectedCompany ? [selectedCompany] : []}
                                />
                            </Form.Item>
                            {/* <Form.Item label="Batch Number" name="batchNumber" initialValue={details.batchNumber}>
                                <Input value={details.batchNumber} />
                            </Form.Item> */}
                            {/* <Form.Item label="Studio Code" name="studioCode" initialValue={details.studioCode}>
                                <Input value={details.studioCode} />
                            </Form.Item> */}
                            {/* <Form.Item label="First Barcode Number" name="startAt" initialValue={details.startAt}>
                                <InputNumber value={details.startAt} />
                            </Form.Item> */}
                            <Form.Item label="Number of Articles" name="totalCount" initialValue={details.totalCount}>
                                <InputNumber value={details.totalCount} step="1" />
                            </Form.Item>
                        </div>
                        <div className="dimensions-box">
                            <div className="padding-form-box">
                                <p>Page dimensions</p>
                                <Form.Item label="Page width" name="pageWidth" initialValue={details.pageWidth}>
                                    <InputNumber value={details.pageWidth} step="1" addonAfter="mm" />
                                </Form.Item>
                                <Form.Item label="Page Height" name="pageHeight" initialValue={details.pageHeight}>
                                    <InputNumber value={details.pageHeight} step="1" addonAfter="mm" />
                                </Form.Item>
                            </div>

                            <div className="padding-form-box">
                                <p>Page Padding</p>
                                <Form.Item label="top" name="top" initialValue={details.pagePadding.top}>
                                    <InputNumber value={details.pagePadding.top} addonAfter="mm" />
                                </Form.Item>
                                <Form.Item label="right" name="right" initialValue={details.pagePadding.right}>
                                    <InputNumber value={details.pagePadding.right} addonAfter="mm" />
                                </Form.Item>
                                <Form.Item label="bottom" name="bottom" initialValue={details.pagePadding.bottom}>
                                    <InputNumber value={details.pagePadding.bottom} addonAfter="mm" />
                                </Form.Item>
                                <Form.Item label="left" name="left" initialValue={details.pagePadding.left}>
                                    <InputNumber value={details.pagePadding.left} addonAfter="mm" />
                                </Form.Item>
                            </div>
                            <div className="padding-form-box">
                                <p>Gap between barcodes</p>
                                <Form.Item label="horizontal" name="horizontal" initialValue={details.gapBetweenBarcodes.horizontal}>
                                    <InputNumber addonAfter="mm" value={details.gapBetweenBarcodes.horizontal} />
                                </Form.Item>
                                <Form.Item label="vertical" name="vertical" initialValue={details.gapBetweenBarcodes.vertical}>
                                    <InputNumber addonAfter="mm" value={details.gapBetweenBarcodes.vertical} />
                                </Form.Item>
                            </div>
                        </div>
                        <div className="padding-form-box">
                            <p>Number of columns and rows</p>
                            <Form.Item label="Columns" name="columns" initialValue={details.columns}>
                                <Input value={details.columns} />
                            </Form.Item>
                            <Form.Item label="Rows" name="rows" initialValue={details.rows}>
                                <Input value={details.rows} />
                            </Form.Item>
                        </div>
                        <div className="buttonBox">
                            <Form.Item>
                                <Button type="primary" htmlType="submit">
                                    Submit
                                </Button>
                            </Form.Item>

                            <Form.Item>
                                <Button type="default" htmlType="reset">
                                    Reset
                                </Button>
                            </Form.Item>
                        </div>
                    </Form>
                </div>

                <div className="print-preview-area">
                    {!!isBarcodeViewValid() && (
                        <>
                            <div ref={componentRef}>
                                <GeneratePages />
                            </div>
                        </>
                    )}
                </div>
                <Button onClick={handlePrint2} type="primary" className="btn-print">
                    <PrinterOutlined />
                </Button>
            </div>
        </React.Fragment>
    );
}
